<template>
  <svg :width="width"
       :height="height"
       :fill="disabled ? disabledStateColor : iconColor"
       viewBox="0 0 9 5"
       xmlns="http://www.w3.org/2000/svg"
       role="presentation"
       @click="$emit('click')">
    <path d="M7.9884 2.04062L6.15087 0.203095C5.88008 -0.0676983 5.45455 -0.0676983 5.20309 0.203095C4.9323 0.473888 4.9323 0.89942 5.20309 1.15087L5.88008 1.82785H0.676983C0.309478 1.82785 0 2.13733 0 2.50484C0 2.87234 0.309478 3.18182 0.676983 3.18182H5.86074L5.18375 3.8588C4.91296 4.12959 4.91296 4.55513 5.18375 4.80658C5.31915 4.94197 5.49323 5 5.66731 5C5.84139 5 6.01547 4.94197 6.15087 4.80658L7.9884 2.96905C8.23985 2.7176 8.23985 2.29207 7.9884 2.04062Z" :fill="disabled ? disabledStateColor : iconColor"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>